import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M12 3.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM8.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", { d: "M12 14c-1.758 0-3.61.577-5.035 1.601C5.538 16.628 4.5 18.14 4.5 20a.5.5 0 0 0 1 0c0-1.453.805-2.692 2.05-3.587C8.796 15.516 10.443 15 12 15s3.203.516 4.45 1.413c1.245.895 2.05 2.134 2.05 3.587a.5.5 0 0 0 1 0c0-1.86-1.038-3.372-2.465-4.399C15.61 14.578 13.758 14 12 14Z" }, null, -1)
  ]))]))
}
export default { render: render }